export const Wordmark = ({ light = false, className = "" }) => (
  <span className={`flex flex-col leading-none select-none ${className}`}>
    <span
      className={`font-serif text-[28px] md:text-[34px] tracking-tight ${
        light ? "text-[#F4F3EF]" : "text-[#1A1C19]"
      }`}
    >
      {"M&K"}
    </span>
    <span
      className={`text-[11px] md:text-xs font-semibold tracking-[0.28em] mt-1.5 ${
        light ? "text-[#C9BCA0]" : "text-[#3A4036]"
      }`}
    >
      PROPERTIES
    </span>
  </span>
);
